export const BASE = 4;

export const SPACING_0B = '0px';
export const SPACING_1 = '1px';
export const SPACING_2 = '2px';
export const SPACING_3 = '3px';
export const SPACING_5 = '5px';
export const SPACING_1B = `${BASE}px`;
export const SPACING_6 = '6px';
export const SPACING_13 = '13px';
export const SPACING_14 = '14px';
export const SPACING_15 = '15px';
export const SPACING_10 = '10px';
export const SPACING_17 = '17px';
export const SPACING_18 = '18px';
export const SPACING_20 = '20px';
export const SPACING_22 = '22px';
export const SPACING_23 = '23px';
export const SPACING_32 = '32px';
export const SPACING_26 = '26px';
export const SPACING_50 = '50px';
export const SPACING_94 = '94px';
export const SPACING_2B = `${2 * BASE}px`;
export const SPACING_3B = `${3 * BASE}px`;
export const SPACING_4B = `${4 * BASE}px`;
export const SPACING_5B = `${5 * BASE}px`;
export const SPACING_6B = `${6 * BASE}px`;
export const SPACING_7B = `${7 * BASE}px`;
export const SPACING_8B = `${8 * BASE}px`;
export const SPACING_9B = `${9 * BASE}px`;
export const SPACING_10B = `${10 * BASE}px`;
export const SPACING_11B = `${11 * BASE}px`;
export const SPACING_12B = `${12 * BASE}px`;
export const SPACING_13B = `${13 * BASE}px`;
export const SPACING_14B = `${14 * BASE}px`;
export const SPACING_15B = `${15 * BASE}px`;
export const SPACING_16B = `${16 * BASE}px`;
export const SPACING_17B = `${17 * BASE}px`;
export const SPACING_18B = `${18 * BASE}px`;
export const SPACING_19B = `${19 * BASE}px`;
export const SPACING_20B = `${20 * BASE}px`;
export const SPACING_21B = `${21 * BASE}px`;
export const SPACING_22B = `${22 * BASE}px`;
export const SPACING_23B = `${23 * BASE}px`;
export const SPACING_24B = `${24 * BASE}px`;
export const SPACING_25B = `${25 * BASE}px`;
export const SPACING_26B = `${26 * BASE}px`;
export const SPACING_27B = `${27 * BASE}px`;
export const SPACING_28B = `${28 * BASE}px`;
export const SPACING_30B = `${30 * BASE}px`;
export const SPACING_31B = `${31 * BASE}px`;
export const SPACING_32B = `${32 * BASE}px`;
export const SPACING_33B = `${33 * BASE}px`;
export const SPACING_35B = `${35 * BASE}px`;
export const SPACING_36B = `${36 * BASE}px`;
export const SPACING_38B = `${38 * BASE}px`;
export const SPACING_40B = `${40 * BASE}px`;
export const SPACING_45B = `${45 * BASE}px`;
export const SPACING_50B = `${50 * BASE}px`;
export const SPACING_60B = `${60 * BASE}px`;
export const SPACING_90B = `${90 * BASE}px`;
export const SPACING_120B = `${120 * BASE}px`;
export const SPACING_70B = `${70 * BASE}px`;

// To give two spaces in text when sending from function. &nbsp; just not work here.
export const SPACING_2SPACES = '\u00a0\u00a0';
export const SPACING_1SPACE = '\u00a0';

export const SPACING_HEADER = 72;
export const SPACING_HEADER_MARGIN = 40;
export const SPACING_FOOTER = 220;
export const SPACING_FOOTER_MARGIN = 40;

export const APP_CONTAINER_WIDTH = '1136px';
export const ICONS_COURSE_CONTAINER_WIDTH = '848px';

export const SECTION_SPACING = {
  DESKTOP: '80px',
  MOBILE: '40px'
};
